import { Button, Card, Checkbox, Elevation, FormGroup, HTMLSelect, InputGroup, Radio, RadioGroup } from "@blueprintjs/core";
import { DateInput } from "@blueprintjs/datetime";
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import fetch from "node-fetch";
import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import dateUtils from '../../../utils/date';
import numberUtils from '../../../utils/number';


const getJsFormatter = {
  // note that locale argument comes from locale prop and may be undefined
  formatDate: (date) => date.toLocaleDateString(),
  parseDate: str => new Date(str),
  // maxDate: () => {
  //   let date = new Date();
  //   return date.setMonth(date.getMonth + 24);
  // }
};

class RentDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locations: [],
      leaseTenurePeriod: Array.from(new Array(60), (val, index) => index + 1),
      lockinPeriod: [],
      step: 0,
      loading: true,
      // selectedLocation: null,
      values: {
        uid: '',
        cityUid: '',
        name: '',
        mobile: '',
        email: '',
        isRentIncremental: false,
        createdBy: '',
        startDate: '',
        endDate: '',
        lockinPeriodInMonths: '',
        depositAmount: '',
        nonRefundableDepositAmount: '',
        monthlyRentAmount: '',
        maintenanceChargePaidBy: '',
        registrationChargePaidBy: '',
        rentIncrementMode: '',
        rentIncrementValue: '',
        rentIncrementInMonths: ''
      },
      formError: {},
      formMobileErrorMessage: '',
    }
  }

  componentWillMount() {
    this.fetchCities();
    if (this.props.match.params.id) {
      this.fetchLeaseDetails();
    } else {
      this.setState({ loading: false })
    }
  }

  fetchLeaseDetails = () => {
    let URL = `/v2/lease/detail?uid=${this.props.match.params.id}`;
    let { lockinPeriod } = this.state;
    fetch(URL)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        if (result.message !== 'Ok') {
          console.log(result.message);
          return;
        }
        if (result.data.status !== "New") {
          this.props.history.push({
            pathname: `/rentagreement/details/${result.data.uid}`
          });
        }
        const data = {};
        for (const key in result.data) {
          if (key in this.state.values) {
            data[key] = result.data[key];
          }
        }
        data.leaseTenure = dateUtils.monthDiff(result.data.startDate, result.data.endDate)
        data.startDate = new Date(result.data.startDate)
        data.endDate = new Date(result.data.endDate)
        if (data.leaseTenure)
          lockinPeriod = Array.from(new Array(parseInt(data.leaseTenure)), (val, index) => index + 1);
        this.setState({
          values: data,
          loading: false,
          lockinPeriod
        })
      });
  }

  fetchCities() {
    let URL = '/v1/cities?stateUid=mh';
    fetch(URL)
      .then(response => response.json())
      .then((result) => {
        if (result.message !== 'Ok') {
          console.log(result.message);
          return;
        }
        this.setState({ locations: result.data });
      });
  }

  validateForm = () => {
    let isFormValid = true;
    let formValues = this.state.values;
    let errors = this.state.formError;
    let { formMobileErrorMessage } = this.state;
    let rentIncrementList = ['rentIncrementInMonths', 'rentIncrementMode', 'rentIncrementValue', 'isRentIncremental'];
    Object.keys(formValues).forEach(function (key) {
      if ((rentIncrementList.includes(key) && !formValues.isRentIncremental) || formValues[key]) {
        if (key === 'mobile') {
          if (!numberUtils.isMobile(formValues[key])) {
            errors[key] = true;
            isFormValid = false;
            formMobileErrorMessage = "Mobile number is not valid"
          } else {
            errors[key] = false
            formMobileErrorMessage = '';
          }
        } else {
          errors[key] = false
        }
      } else if (key === "nonRefundableDepositAmount" || key === "lockinPeriodInMonths" || key === "uid") {
        errors[key] = false
      }
      else {
        errors[key] = true;
        isFormValid = false;
        if (key === 'mobile') {
          formMobileErrorMessage = "This field is required"
        }
      }
    })
    this.setState({ errors, formMobileErrorMessage: formMobileErrorMessage });
    return isFormValid;
  }

  textInputChange = (event) => {
    let values = this.state.values;
    const { id, value } = event.target;
    values[id] = value;
    const newState = { values };
    if (id === "leaseTenure") {
      newState.lockinPeriod = Array.from(new Array(parseInt(value)), (val, index) => index + 1);
      if (this.state.values.startDate) {
        values.endDate = dateUtils.addMonthsUTC(values.startDate, parseInt(this.state.values.leaseTenure));
      }
    } if (id === "cityUid") {
      this.props.onChangeLocation(this.state.locations.filter(item => item.uid === value)[0])
    }
    this.setState(newState);
  }

  otherInputChange = (value, id) => {
    let values = this.state.values;
    values[id] = value;
    this.setState({ values });
  }

  dateInputChange = (value, id) => {
    let values = this.state.values;
    // values[id] = dateUtils.dateFormat(value);
    values[id] = value;
    if (this.state.values.leaseTenure) {
      let newDate = dateUtils.addMonthsUTC(new Date(value), parseInt(this.state.values.leaseTenure));
      values.endDate = newDate;
    }
    this.setState({ values });
  }

  handleClick = () => {
    if (this.validateForm()) {
      this.setState({ loadToggle: true });
      let URL = `/v2/lease/create`;
      const values = this.state.values;
      let data = {
        name: values.name,
        mobile: values.mobile,
        email: values.email,
        cityUid: values.cityUid,
        createdBy: values.createdBy,
        startDate: dateUtils.dateFormat(values.startDate),
        endDate: dateUtils.dateFormat(values.endDate),
        lockinPeriodInMonths: parseInt(values.lockinPeriodInMonths ? values.lockinPeriodInMonths : 0),
        monthlyRentAmount: parseInt(values.monthlyRentAmount),
        depositAmount: parseInt(values.depositAmount),
        nonRefundableDepositAmount: (values.nonRefundableDepositAmount ? values.nonRefundableDepositAmount : 0),
        registrationChargePaidBy: values.registrationChargePaidBy,
        maintenanceChargePaidBy: values.maintenanceChargePaidBy,
        isRentIncremental: values.isRentIncremental,
        rentIncrementInMonths: parseInt(values.rentIncrementInMonths),
        rentIncrementMode: values.rentIncrementMode,
        rentIncrementValue: parseInt(values.rentIncrementValue)
      }
      // if (this.state.values.uid) {
      //   URL = "/v2/lease/update";
      //   data.uid = this.state.values.uid;
      // }
      fetch(URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
        body: JSON.stringify(data)
      })
        .then((response) => {
          return response.json();
        })
        .then((result) => {
          if (result.message === 'Ok') {
            if (result.data && result.data.uid) {
              this.props.history.push({
                pathname: `/rentagreement/details/${result.data.uid}`,
                data: result.data
              });
            }
          }
        });
    }
  }

  render() {
    const { values } = this.state;
    if (this.state.loading) {
      return (
        <div className="has-text-centered has-text-grey-light search-loader">
          <FontAwesomeIcon icon={faCircleNotch} spin size="4x" />
        </div >
      )
    }
    return (
      <div className="details-form">
        <Card className="card" elevation={Elevation.ONE}>
          <div className="columns is-multiline is-variable is-3 rent-details">
            <div className="column is-6 col-thin-ex">
              <FormGroup
                helperText={this.state.formError.cityUid && "This field is required"}
                intent="warning"
              >
                <HTMLSelect
                  required
                  id="cityUid"
                  className="wide-select"
                  fill
                  large
                  onChange={this.textInputChange}
                  value={values.cityUid || 0}
                >
                  <option value={0} disabled>Select Location</option>
                  {this.state.locations.length ?
                    this.state.locations.map((item, i) => (
                      <option value={item.uid} key={item.uid}>{item.name}</option>
                    )) :
                    <option disabled>Loading options ...</option>
                  }
                </HTMLSelect>
              </FormGroup>
            </div>
            <div className="column is-6 col-thin-ex"></div>
            <div className="column is-12 col-thin-ex">
              <FormGroup
                helperText={this.state.formError.createdBy && "This field is required"}
                intent="warning"
              >
                <p className="is-size-5" style={{ marginBottom: 5 }}>You are?</p>
                <RadioGroup
                  inline
                  required
                  id="createdBy"
                  onChange={(e) => this.otherInputChange(e.target.value, "createdBy")}
                  selectedValue={values.createdBy}
                >
                  <Radio label="Owner" value="Landlord" large />
                  <Radio label="Tenant" value="Tenant" large />
                </RadioGroup>
              </FormGroup>
            </div>
            <div className="column is-6 col-thin-ex">
              <FormGroup
                helperText={this.state.formError.name && "This field is required"}
                intent="warning"
              >
                <InputGroup onChange={this.textInputChange} value={values.name} large id="name" placeholder="Name" type="text" />
              </FormGroup>
            </div>
            <div className="column is-6 col-thin-ex"></div>
            <div className="column is-6 col-thin-ex">
              <FormGroup
                helperText={this.state.formError.mobile && this.state.formMobileErrorMessage}
                intent="warning"
              >
                <InputGroup onChange={this.textInputChange} value={values.mobile} large id="mobile" type="number" placeholder="Mobile Number" />
              </FormGroup>
            </div>
            <div className="column is-6 col-thin">
              <FormGroup
                helperText={this.state.formError.email && "This field is required"}
                intent="warning"
              >
                <InputGroup onChange={this.textInputChange} value={values.email} large id="email" type="email" placeholder="Email Id" />
              </FormGroup>
            </div>
            <div className="column is-6 col-thin-ex">
              <FormGroup
                helperText={this.state.formError.startDate && "This field is required"}
                intent="warning"
              >
                <DateInput inputProps={{ large: true }}
                  {...getJsFormatter}
                  onChange={(value) => this.dateInputChange(value, "startDate")}
                  value={values.startDate || null}
                  id="startDate" placeholder="Lease Start Date"
                  required
                />
              </FormGroup>
            </div>
            <div className="column is-6 col-thin-ex">
              <FormGroup
                helperText={this.state.formError.endDate && "This field is required"}
                intent="warning"
              >
                <HTMLSelect
                  id="leaseTenure"
                  className="wide-select"
                  fill
                  large
                  onChange={this.textInputChange}
                  value={values.leaseTenure || 0}
                  required
                >
                  <option value={0} disabled>Lease Tenure</option>
                  {this.state.leaseTenurePeriod.map((item, i) => (
                    <option value={item} key={item}>{item} months</option>
                  ))}
                </HTMLSelect>
              </FormGroup>
            </div>
            <div className="column is-6 col-thin-ex">
              <FormGroup>
                <InputGroup disabled large id="endDate" placeholder="Lease End Date"
                  value={values.endDate ? values.endDate.toLocaleDateString() : ''} />
              </FormGroup>
            </div>
            <div className="column is-6 col-thin-ex">
              <FormGroup
                helperText={this.state.formError.lockinPeriodInMonths && "This field is required"}
                intent="warning"
              >
                <HTMLSelect
                  id="lockinPeriodInMonths"
                  className="wide-select"
                  fill
                  large
                  disabled={values.leaseTenure ? false : true}
                  onChange={this.textInputChange}
                  value={values.lockinPeriodInMonths || 0}
                  required
                >
                  <option value={0} disabled>Lockin Period</option>
                  {this.state.lockinPeriod.map((item, i) => (
                    <option value={item} key={item}>{item} months</option>
                  ))}
                </HTMLSelect>
              </FormGroup>
            </div>
            <div className="column is-6 col-thin-ex">
              <FormGroup
                helperText={this.state.formError.depositAmount && "This field is required"}
                intent="warning"
              >
                <InputGroup onChange={this.textInputChange} value={values.depositAmount} large id="depositAmount" type="number" placeholder="Refundable Deposit" />
              </FormGroup>
            </div>
            <div className="column is-6 col-thin-ex">
              <FormGroup
                helperText={this.state.formError.nonRefundableDepositAmount && "This field is required"}
                intent="warning"
              >
                <InputGroup onChange={this.textInputChange} value={values.nonRefundableDepositAmount} type="number"
                  large id="nonRefundableDepositAmount" placeholder="Non Refundable Deposit" />
              </FormGroup>
            </div>
            <div className="column is-6 col-thin-ex">
              <FormGroup
                helperText={this.state.formError.monthlyRentAmount && "This field is required"}
                intent="warning"
              >
                <InputGroup onChange={this.textInputChange} value={values.monthlyRentAmount} type="number" large id="monthlyRentAmount" placeholder="Rent Amount (Monthly)" />
              </FormGroup>
            </div>
            <div className="column is-6 col-thin-ex"></div>
            <div className="column is-6 col-thin-ex">
              <FormGroup>
                <Checkbox
                  id="isRentIncremental"
                  onChange={(e) => this.otherInputChange(e.target.checked, "isRentIncremental")}
                  checked={values.isRentIncremental}
                  large
                >
                  Rent Incremental
                </Checkbox>
              </FormGroup>
            </div>
            <div className="column is-6 col-thin-ex">
              {values.isRentIncremental ?
                <FormGroup
                  helperText={this.state.formError.rentIncrementInMonths && "This field is required"}
                  intent="warning"
                >
                  <InputGroup onChange={this.textInputChange}
                    value={values.rentIncrementInMonths}
                    large id="rentIncrementInMonths" placeholder="Rent Increment In Months" type="number" />
                </FormGroup>
                : null
              }
            </div>
            {values.isRentIncremental ?
              <Fragment>
                <div className="column is-6 col-thin-ex">
                  <FormGroup helperText={this.state.formError.rentIncrementMode && "This field is required"}
                    intent="warning"
                  >
                    <HTMLSelect
                      required
                      id="rentIncrementMode"
                      className="wide-select"
                      fill
                      large
                      onChange={this.textInputChange}
                      value={values.rentIncrementMode || 0}
                    >
                      <option value={0} disabled>Incremental By</option>
                      <option value="Percent">Percent</option>
                      <option value="Fixed">Fixed</option>
                    </HTMLSelect>
                  </FormGroup>
                </div>
                <div className="column is-6 col-thin-ex">
                  <FormGroup
                    helperText={this.state.formError.rentIncrementValue && "This field is required"}
                    intent="warning"
                  >
                    <InputGroup onChange={this.textInputChange}
                      value={values.rentIncrementValue}
                      large id="rentIncrementValue" placeholder="Incremental Value" type="number" />
                  </FormGroup>
                </div>
              </Fragment>
              : null
            }
            <div className="column is-6 col-thin-ex">
              <FormGroup
                helperText={this.state.formError.maintenanceChargePaidBy && "This field is required"}
                intent="warning"
              >
                <HTMLSelect
                  id="maintenanceChargePaidBy"
                  className="wide-select"
                  fill
                  large
                  onChange={this.textInputChange}
                  value={values.maintenanceChargePaidBy || 0}
                  required
                >
                  <option value={0} disabled>Maintenance Paid By</option>
                  <option value="Landlord">Owner</option>
                  <option value="Tenant">Tenant</option>
                </HTMLSelect>
              </FormGroup>
            </div>
            <div className="column is-6 col-thin-ex">
              <FormGroup
                helperText={this.state.formError.registrationChargePaidBy && "This field is required"}
                intent="warning"
              >
                <HTMLSelect
                  id="registrationChargePaidBy"
                  className="wide-select"
                  fill
                  large
                  onChange={this.textInputChange}
                  value={values.registrationChargePaidBy || 0}
                  required
                >
                  <option value={0} disabled>Registration Paid By</option>
                  <option value="Landlord">Owner</option>
                  <option value="Tenant">Tenant</option>
                  <option value="Both">Both</option>
                </HTMLSelect>
              </FormGroup>
            </div>
          </div>
        </Card>
        <div className="btn-block">
          <Button
            disabled
            type="button"
            intent="primary"
            text="Submit"
            // onClick={() => this.handleClick()}
            fill
            large
          />
        </div>
      </div>
    );
  }
}

export default withRouter(RentDetails);


// WEBPACK FOOTER //
// ./src/app/components/rent-agreement/rent-details.js